export default {
    '批量添加完成':'Batch addition completed',
    '教师导入模板':'Teacher import template',
    '学生导入模板':'Student import template',
    '导入中请不要退出当前页面。':'Do not exit the current page during the import.',
    '人脸导入{name}':'Face import {name}',
    '手机号':'Mobile phone number',
    '姓名':'Name',
    '工号':'Employee ID',
    '只能导入格式为':'Only files in the formats of png, jpg, jpeg can be imported. The file naming format is (mobile phone number or name or employee ID), and the size of a single face image should not exceed 10M.',
    '导入成功数量：':'Number of successful imports:',
    '导入失败数量：':'Number of failed imports:',
    '点击导入':'Click to import',
    '导入失败人员列表':'List of failed import personnel',
    '失败原因':'Failure reason',
    '表格数据':'Table data',
    '正在准备图片':'Preparing pictures',
    '压缩图片中':'Compressing pictures',
    '文件超过10MB':'File exceeds 10MB',
    '图片损坏无法打开':'Picture is damaged and cannot be opened',
    '文件格式错误':'File format error',
    '数据导入成功，但有失败数据。请点击':'Data import was successful, but there is failed data. Please click',
    '教师信息':'Teacher information',
    '编辑教职工':'Edit faculty and staff',
    '新增教职工':'Add new faculty and staff',
    '请输入用户名称':'Please enter the user name',
    '请输入登录账号':'Please enter the login account',
    '登录账号已存在，请重新输入':'The login ID already exists. Please enter a different one.',
    '登录账号长度最多为20位':'The length of the login account should be at most 20 digits',
    '登录账号长度至少为6位':'The length of the login account should be at least 6 digits',
    '请输入有效的账号':'Please enter a valid account',
    '请输入登录密码':'Please enter the login password',
    '账号密码格式仅支持大小写字母、数字及特殊符号':'The account password format only supports uppercase and lowercase letters, numbers, and special symbols',
    '登录密码长度至少为8位':'The length of the login password should be at least 6 digits',
    '请选择角色':'Please select a role',
    '请输入手机号':'Please enter the mobile phone number',
    '请输入正确的手机号':'Please enter the correct mobile phone number',
    '请选择性别':'Please select the gender',
    '请输入姓名':'Please enter the name',
    '正在加载数据，请稍后':'Loading data, please wait...',
    '用户信息':'User information',
    '登录账号':'Login account',
    '请输入6':'Please enter a combination of 6 - 20 pure digits/letters or digits + letters',
    '登录密码':'Login password',
    '重置密码':'Reset password',
    '角色':'Role',
    '执教班级':'Teaching class',
    '请选择执教班级':'Please select the teaching class',
    '工号':'Employee ID',
    '请输入工号':'Please enter the employee ID',
    'ID卡号':'ID card number',
    'ID卡号仅支持数字':'The ID card number only supports digits',
    '请填写ID卡号':'Please fill in the ID card number',
    '账户信息':'Account information',
    '账户信息是该账户下所有用户的公用信息':'Account information is the common information for all users under this account',
    '去认证':'Go to authenticate',
    '证件类型':'Certificate type',
    '请选择证件类型':'Please select the certificate type',
    '证件号':'Certificate number',
    '请输入证件号':'Please enter the certificate number',
    '人脸照片':'Face photo',
    '认证手机号':'Authenticated mobile phone number',
    '教职工管理':'Faculty and staff management',
    '请输入名称':'Please enter the name/account',
    '批量新增教师':'Batch add new teachers',
    '批量导出教师':'Batch export teachers',
    '批量添加照片':'Batch add photos',
    '批量删除教师':'Batch delete teachers',
    '新增教师':'Add new teacher',
    '批量导入教师人脸':'Batch import teachers faces',
    '是否删除此用户？':'Do you want to delete this user?',
    '删除教师':'Delete teacher',
    '请选择教师':'Please select a teacher',
    '导入中请不要退出当前页面。':'Do not exit the current page during the import.',
    '学籍号人脸导入':'Student ID face import',
    '姓名人脸导入':'Name face import',
    '只能导入格式为学籍号':'Only files in the formats of png, jpg, jpeg can be imported. The file naming format is (student ID or name), and the size of a single face image should not exceed 10M.',
    '学生信息':'Student information',
    '编辑学生':'Edit student',
    '新增学生':'Add new student',
    '请选择班级':'Please select a class',
    '学籍号已注册':'The student ID has been registered',
    '数据保存成功':'Data saved successfully',
    '请填写家长姓名':'Please fill in the parent\'s name',
    '请填写家长性别':'Please fill in the parent\'s gender',
    '请填写家长关系':'Please fill in the parent - child relationship',
    '请填写家长联系方式':'Please fill in the parent\'s contact information',
    '为空则系统自动生成':'Leave blank for the system to auto-generate',
    '家长{num}的联系方式格式不正确，请重新填写':'The contact information format of parent {num} is incorrect. Please fill it in again.',
    '家长姓名':'Parent\'s name',
    '家长关系':'Parent - child relationship',
    '联系方式':'Contact information',
    '家长手机号':'Parent\'s mobile phone number',
    '学号':'Student number',
    '请输入学号':'Please enter the student number',
    '请输入学籍号':'Please enter the student ID',
    '民族':'Ethnic group',
    '请选择民族':'Please select an ethnic group',
    '家长信息':'Parent information',
    '新增家长':'Add new parent',
    '确认删除吗':'Confirm deletion?',
    '用户列表':'User list',
    '请输入姓名或账号':'Please enter the name or account',
    '批量删除':'Batch delete',
    '人脸批量导入':'Batch import faces',
    '批量导入人脸照片':'Batch import face photos',
    '关闭后，将中止上传':'Upload will be aborted after closing.',
    '已成功的照片不受影响':'The successfully uploaded photos will not be affected.',
    '删除学生':'Delete student',
    '请选择学生':'Please select a student',
    '家长信息':'Parent information',
    '编辑家长':'Edit parent',
    '新增家长':'Add new parent',
    '请输入家长姓名':'Please enter the parent\'s name.',
    '请输入家长手机号':'Please enter the parent\'s mobile phone number.',
    '请输入正确的家长手机号':'Please enter a valid parent\'s mobile phone number.',
    '该学生已存在相同登录账号的家长':'A parent with the same login ID already exists for this student.',
    '该学生已存在相同手机的家长':'A parent with the same mobile phone number already exists for this student.',
    '子女信息不能为空':'Child information cannot be empty',
    '学生姓名':'Student\'s name',
    '保存用户成功':'User saved successfully',
    '子女信息':'Child information',
    '编辑用户':'Edit user',
    '新增用户':'Add new user',
    '组织结构':'Organizational structure',
    '请选择组织结构':'Please select an organizational structure',
    '请选择院系':'Please select a department',
    '学籍号已注册':'The student ID has been registered',
    '请输入名称与账号':'Please enter the name/account/mobile phone number/student ID',
    '批量导入学生':'Batch import students',
    '批量导出学生':'Batch export students',
    '批量导出家长':'Batch export parents',
    '批量删除家长':'Batch delete parents',
    '是否停用此用户？':'Deactivate this user？',
    '删除家长':'Delete parents',
    '请选择家长':'Please select a parent.',
    '获取验证码':'Get Verification Code',
    '请输入手机验证码':'Please enter the SMS code',
    '手机验证码':'SMS Verification Code',
    '认证':'Verify',
    '手机号不能为空！':'Mobile number cannot be empty!',
    '手机验证码不能为空！':'SMS code cannot be empty!',
    '账号信息':'Account Information',
    '请输入姓名，不超过20个字':'Please enter your name (up to 20 characters)',
    '编辑角色账号信息':'Edit Role Account',
    '角色账号信息更新成功':'Role Account Updated Successfully',
    '账户信息修改将会影响该账户下所有用户的共有信息。':'Modifying account information will affect shared data for all users under this account.',
    '编辑账户信息':'Edit Account',
    '账户信息更新成功':'Account Information Updated Successfully',
    '用户反馈':'User Feedback',
    '登录密码不能为空':'Password cannot be empty',
    '进入':'Enter',

    //25-7-31
    '市民管理':'Citizen management',
    '注册场所':'Registered place',
    '注册时间':'Registration time',
    '批量新增市民':'Batch addition of citizens',
    '批量导出市民':'Batch export of citizens',
    '批量删除市民':'Bulk deletion of citizens',
    '新增市民':'New citizens',
    '编辑市民':'Editor of the citizens',
    //25-8-1
    '操作成功':'Pperate successfully',
    '用户名称':'Username',
    '登录账号':'Login ID',
    '注册来源':'Registration source',
    '获取成功':'Acquire success',
    '市民信息':'Citizen Information',
    '生日':'Birthday',
    '家庭住址':'Home Address',
    '学生':'Student',
    '游客':'Visitor',
}    
